import { render, staticRenderFns } from "./DropdownSearchResultLoader.vue?vue&type=template&id=f3670b8e&scoped=true&"
import script from "./DropdownSearchResultLoader.vue?vue&type=script&lang=js&"
export * from "./DropdownSearchResultLoader.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSearchResultLoader.vue?vue&type=style&index=0&id=f3670b8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3670b8e",
  null
  
)

export default component.exports